module.exports = __webpack_public_path__ + "img/google-pay-wordmark.a1bdf1be.svg";